
import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import _ from 'lodash';

const MergeBaseMappingForm = forwardRef(function MergeBaseMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { instanceId, instanceName } = props.record;
      return [{id: instanceId, name: instanceName }]
    }
    return [];
  });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = useCallback((config) => {
    const { instanceId } = config;
    return {
      instanceId,
      instanceName: projects.find(project => project.id === instanceId)?.name
    };
  }, [projects]);

  const extraFields = useMemo(() => ([{
      name: 'instanceId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Application Name',
      options: parseSelectOptions(projects),
      required: true,
      loading: _.isUndefined(projects),
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default MergeBaseMappingForm;
